var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"page-header__container"},[_c('div',{staticClass:"page-header__title",attrs:{"data-test":"page-header__title"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }